<!-- 农贸市场详情 -->
<template>
  <div class="dialog-agricultural">
    <div class="header">
      <div class="title">{{ data.mc || '-' }}</div>
    </div>
    <div class="body">
      <div class="content">
        <div class="descriptions-group">
          <div class="descriptions-item">
            <span class="key">业主单位:</span>
            <span class="value">{{ data.yzdw || '-' }}</span>
          </div>
          <div class="descriptions-item">
            <span class="key">营业面积（m³）:</span>
            <span class="value">{{ data.scmj || '-' }}</span>
          </div>
          <div class="descriptions-item">
            <span class="key">责任区县:</span>
            <span class="value">{{ data.xzqhmc || '-' }}</span>
          </div>
          <div class="descriptions-item">
            <span class="key">责任乡镇:</span>
            <span class="value">{{ data.zrxz || '-' }}</span>
          </div>
          <div class="descriptions-item">
            <span class="key">经济性质:</span>
            <span class="value">{{ data.jjxz || '-' }}</span>
          </div>
          <div class="descriptions-item">
            <span class="key">市场形态:</span>
            <span class="value">{{ data.scxt || '-' }}</span>
          </div>
          <div class="descriptions-item">
            <span class="key">排水去向:</span>
            <span class="value">{{ data.psqx || '-' }}</span>
          </div>
          <div class="descriptions-item">
            <span class="key">受纳水体:</span>
            <span class="value">{{ data.snst || '-' }}</span>
          </div>
          <div class="descriptions-item">
            <span class="key">经度:</span>
            <span class="value">{{ data.jd || '-' }}</span>
          </div>
          <div class="descriptions-item">
            <span class="key">纬度:</span>
            <span class="value">{{ data.wd || '-' }}</span>
          </div>
          <div class="descriptions-item">
            <span class="key">联系人:</span>
            <span class="value">{{ data.fzr || '-' }}</span>
          </div>
          <div class="descriptions-item">
            <span class="key">联系方式:</span>
            <span class="value">{{ data.fzrdh || '-' }}</span>
          </div>
          <div class="descriptions-item width100">
            <span class="key">详细地址:</span>
            <span class="value">{{ data.sssq || '-' }}</span>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import { toRefs, nextTick, getCurrentInstance, onMounted } from 'vue'
import { ref } from 'vue-demi'
const props = defineProps({
  // eslint-disable-next-line no-undef
  data: Object,
})
const { data } = toRefs(props)
</script>

<style lang="scss" scoped>
.dialog-agricultural {
  width: 53.35rem;
  min-width: 53.35rem;
  .header {
    text-align: left;
    margin-bottom: 5px;
    border-bottom: 1px solid #ddd;
    .title {
      font-family: Microsoft YaHei;
      font-style: normal;
      font-weight: bold;
      height: 32px;
      font-size: 16px;
    }
  }
  .body {
    .content {
      margin-bottom: 2rem;
      .descriptions-group {
        overflow: hidden;
        h5 {
          font-size: 14px;
          margin: 10px 0;
        }
        .descriptions-item {
          width: 50%;
          float: left;
          line-height: 2.65rem;
          margin-bottom: 1rem;
          display: flex;
          &.width100 {
            width: 100%;
          }
          &:last-of-type {
            margin-bottom: 1.4rem;
          }
          .key {
            display: inline-block;
            color: #ffffff;
            width: 12.8rem;
            margin-right: 1.9rem;
            text-align: left;
          }
        }
      }
    }
  }
}
</style>
